import { createStoreCreator } from 'lib/store'
import reducer from 'reports/gra/reducers'

export default createStoreCreator(reducer)
